import {
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject
} from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "app/shared/auth/auth.service";
import { ButtonComponent } from "app/shared/components/button/button.component";
import { IsLoadingComponent } from "app/shared/components/is-loading/is-loading.component";

@Component({
  selector: "app-introduction-screen",
  templateUrl: "./introduction-screen.component.html",
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IsLoadingComponent]
})
export class IntroductionScreenComponent implements OnInit, OnChanges {
  private router = inject(Router);

  AuthService = inject(AuthService);

  info = this.AuthService.sub;

  initialized = this.AuthService.isInitialized;
  loggedIn = this.AuthService.isLoggedIn;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["loggedIn"] && changes["loggedIn"].currentValue === true) {
      this.router.navigate(["/dashboard"]);
    }
  }

  ngOnInit(): void {
    if (this.loggedIn() === true) {
      this.router.navigate(["/dashboard"]);
    } else {
      this.AuthService.login();
    }
  }

  onLogin() {
    this.AuthService.login();
  }

  onLogout() {
    this.AuthService.logout();
  }
}
